import { useUpdateAssetMutation } from '~generated/hooks'

function useUpdateAssetTags(id: string) {
  const [updateAsset, options] = useUpdateAssetMutation()

  const updateLaunchModuleDetails = (tagsIds: string[]) => {
    updateAsset({
      variables: {
        input: {
          id,
          tagsIds,
        },
      },
    })
  }

  return [updateLaunchModuleDetails, options] as const
}

export default useUpdateAssetTags
